module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-email"
  }, [_c('div', {
    staticClass: "text-xs-center info-hotsite"
  }, [_vm._v("\n    Digite abaixo o seu e-mail de acesso ao portal da administradora do seu condomínio.\n  ")]), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkEmail($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Seu e-mail",
      "append-icon": "email",
      "value": _vm.email
    },
    on: {
      "input": _vm.updateEmail
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "large": "",
      "loading": _vm.loadingEmail,
      "disabled": _vm.loadingEmail,
      "block": ""
    },
    on: {
      "click": _vm.checkEmail
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n    Acessar\n    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)]), _vm._v(" "), _c('cant-access', {
    attrs: {
      "token": _vm.token
    }
  }, [_c('v-btn', {
    staticClass: "btn-hotsite-gray",
    attrs: {
      "large": "",
      "block": ""
    }
  }, [_vm._v("\n    Não estou conseguindo acessar\n    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33b649c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotsite/Checkin.vue
// module id = 743
// module chunks = 23